import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#1760a5",
            // light: "skyblue",
        },
        secondary: {
            main: "#15c630",
        },
        background: {
            default: "#f5f5f5",
        },
        otherColor: {
            main: "#999",
            contrastText: "#fff",
        },
    },
    components: {
        MuiCard: {
          variants: [
            {
                props: { variant: 'ShadowBox' },
                style: {
                  borderRadius: 12,
                  padding: '24px',  // spacing(3) = 24px
                  // maxWidth: '00px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.34)', // manually put the shadow string
                },
            },
          ],
        },
        MuiButton: {
          variants: [
            {
              props: { variant: 'createProject' },
              style: {
                textTransform: 'none',
                borderRadius: 8,
                backgroundColor: '#34cfe3',
              },
            },
          ],
        },
      },
    });

export default theme;

